import React from "react";
import styled from "styled-components";
import { difference, without } from "lodash";
import FilterTag from "../library/FilterTag";
import { useSearchFiltersContext } from "../library/SearchFilter";
import { AllStatus, FilterData } from "./JobListPage";
import { mediaMaxWidth } from "../../theme/mediaQueriesTemplates";

type StatusValue = AllStatus | "active";

const JobListSelectedFilters = (props: Props) => {
  const { filters, userLabelMap, companyLabelMap } = props;

  let statusValues: StatusValue[] = filters.status;

  const activeStates = ["new", "interviewing", "offer_made"] as AllStatus[];
  const hasAllActive = difference(activeStates, filters.status).length === 0;

  if (hasAllActive) {
    statusValues = ["active", ...without(filters.status, ...activeStates)];
  }

  const statusTags = statusValues.map((item) => ({
    label: item.replace("_", " "),
    value: item === "active" ? activeStates : item,
  }));

  const typeTags = filters.type.map((type) => ({
    label: type.replace("_", " "),
    value: type,
  }));

  const companyTags = filters.companies.map((id) => ({
    label: companyLabelMap[id],
    value: id,
  }));

  const userTags = filters.users.map((id) => ({
    label: userLabelMap[id],
    value: id,
  }));

  return (
    <SelectedFiltersWrapper id="job-filter-tags">
      <FilterTagGroup tags={statusTags} filter="status" />
      <FilterTagGroup tags={typeTags} filter="type" />
      <FilterTagGroup tags={userTags} filter="users" />
      <FilterTagGroup tags={companyTags} filter="companies" />
    </SelectedFiltersWrapper>
  );
};

type Tag = {
  label: string;
  value: string | string[];
};

const FilterTagGroup = (props: { filter: string; tags: Tag[] }) => {
  const { tags, filter } = props;
  const { remove } = useSearchFiltersContext();

  if (tags.length === 0) {
    return null;
  }

  return (
    <>
      {tags.map(({ label, value }) => (
        <FilterTag
          key={`${label}-${JSON.stringify(value)}`}
          onClick={() => remove(filter, value)}
        >
          {label}
        </FilterTag>
      ))}
    </>
  );
};

const SelectedFiltersWrapper = styled.div`
  margin-bottom: 0.5rem;
  margin-left: -0.25rem;
  margin-right: -0.25rem;

  ${mediaMaxWidth.smallTablet} {
    display: none;
  }
`;

type Props = {
  filters: FilterData;
  userLabelMap: Record<string, string>;
  companyLabelMap: Record<string, string>;
};

export default JobListSelectedFilters;
